module.exports = __webpack_public_path__ + "4ef0000b2b804d4f7097c90f3a210d33.png";